module.exports = __webpack_public_path__ + "assets/img/school3.9af7d97b.jpg";